import { css, cx, keyframes } from "@emotion/css";
import { PropsOf } from "@emotion/react";
import { mergeProps } from "react-aria";
import { Modal as AriaModal } from "react-aria-components";

import { mq } from "../../utils";

export function _Modal(props: PropsOf<typeof AriaModal>) {
  return (
    <AriaModal
      {...mergeProps(props, {
        className: cx("react-aria-Modal", styles.modal),
      })}
    />
  );
}

const zoom = keyframes`
  from {
    opacity: 0;
    transform: scale(0.9);
  }

  to {
    opacity: 1;
    transform: scale(1);
  }
`;

const slide = keyframes`
  from {
    transform: translateY(50px);
    opacity: 0;
  }

  to {
    transform: translateY(0);
    opacity: 1;
  }
`;

const styles = {
  modal: css(
    {
      borderTopLeftRadius: "var(--border-radius-3)",
      borderTopRightRadius: "var(--border-radius-3)",
      display: "flex",
      maxWidth: "max-content",
      background: "var(--surface-base)",
      boxShadow: "var(--shadow-modal)",

      "&[data-entering]": css(
        mq({
          animation: [`${slide} 100ms ease-out`, `${zoom} 100ms ease-out`],
        })
      ),
      "&[data-exiting]": css(
        mq({
          animation: [
            `${slide} 100ms reverse ease-in`,
            `${zoom} 100ms reverse ease-in`,
          ],
        })
      ),
      ".react-aria-Dialog": css(
        {
          display: "flex",
          flexDirection: "column",
          outline: "none",
          position: "relative",
          borderRadius: "var(--border-radius-3)",
          "&[data-focus-visible]": {
            boxShadow: "var(--focus-action)",
          },
        },
        mq({ minWidth: ["100vw", 320] })
      ),
    },
    mq({
      borderBottomLeftRadius: [0, "var(--border-radius-3)"],
      borderBottomRightRadius: [0, "var(--border-radius-3)"],
    })
  ),
};
